export function filterByTitle<T extends { title: string }>(
  rows: T[],
  search: string,
): T[] {
  const needle = search.trim().toLowerCase();

  if (!needle) {
    return rows;
  }

  return rows.filter((row) => row.title.toLowerCase().includes(needle));
}
